import { PqTimerExtras } from "../../lib/timer";
import { Annotations } from "../../lib/userdata";
import { AttemptId, ItemId, MetadataDataSource, ProductId } from "../datasource";
import {
	AnswerValue, ContentItem, ItemDataSource, PqItemUsage
} from "../datasource/item";
import { ItemModel, MetadataModel } from "../model";

export class TestMetadataModel<P extends ProductId, A extends AttemptId> extends MetadataModel<P, A> {
	constructor(datasource: MetadataDataSource<P, A>) {
		super(datasource);
	}

	getProductId(): Promise<P> {
		return this.datasource.getProductId();
	}

	getAttempt(): Promise<A> {
		return this.datasource.getAttempt();
	}

	getUrl(): Promise<string> {
		return this.datasource.getUrl();
	}

	getScreenshot(): Promise<string> {
		return this.datasource.getScreenshot();
	}
}

export class TestItemModel<P extends ProductId, A extends AttemptId, I extends ItemId> extends ItemModel<P, A, I, PqTimerExtras> {
	constructor(datasource: ItemDataSource<P, A, I, PqTimerExtras>) {
		super(datasource);
	}

	getItem(product: P, id: I, randomize: boolean): Promise<ContentItem<I>> {
		return this.datasource.getItem(product, id, randomize);
	}

	getSameContexts(a: ContentItem<I>, b: ContentItem<I>): ContentItem<I>["contexts"] {
		return this.datasource.getSameContexts(a, b);
	}

	setUserData(product: P, attempt: A, item: I, data: Annotations): Promise<AnswerValue<A, I>> {
		return this.datasource.setUserData(product, attempt, item, data);
	}

	setPing(product: P, attempt: A, times: PqItemUsage<I>[]): Promise<void> {
		return this.datasource.setPing(product, attempt, 'pq_test', times);
	}

	setFinished(product: P, attempt: A): Promise<string> {
		return this.datasource.setFinished(product, attempt);
	}
}
